import { PrintSharp, PropaneTankSharp } from "@mui/icons-material";
import { Box, CardContent, Grid, LinearProgress, LinearProgressProps, Slider, Stack, styled, useTheme } from "@mui/material";
import { linearProgressClasses } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import { useState } from "react";
import { IAutomationModel, IWaterHeaterAutomationModel } from "../../models/Models";
import { useEventHub } from "../../services/EventHub";
import * as Grey from "../StyledComponents";
import { PanelProps } from "./PanelProps";

function GetPulseColor(data: IWaterHeaterAutomationModel) {
    return data.isOn ? 'heatingFrames' : '';
}

export function WaterHeaterPanelSmall(props: PanelProps) {
    const [data, setData] = useState(props.data as IWaterHeaterAutomationModel);
    const [targetTemp, setTargetTemp] = useState(data.targetTemperature);
    const [pulseColors, setPulseColors] = useState(GetPulseColor(data));

    const updateAll = (updated: IAutomationModel | null) => {
        var model = updated as IWaterHeaterAutomationModel;
        if (model) {
            setData(model);
            setTargetTemp(model.targetTemperature);
            setPulseColors(GetPulseColor(model));
        }
    }

    useEventHub<IWaterHeaterAutomationModel>(data.id, updateAll);

    const marks = [
        {
            value: 110,
            label: '110°F',
        },
        {
            value: targetTemp,
            label: `${targetTemp}°F`,
        },
        {
            value: 140,
            label: '140°F',
        },
    ];
    return <Box sx={{ flexGrow: 1, animation: `${pulseColors} 1.5s ease-in-out infinite alternate` }}>
        <Grey.CardTitleButton onClick={props.handleOpen}>
            <Box sx={{ flexGrow: 1 }}>
                <Grey.AutomationTitleSmall className='smallCardTitle' fontSize='14px' sx={{ borderBottom: '1px solid #333' }}>
                    {data?.title}
                    <Stack direction='row' sx={{ padding: 0, position: "absolute", right: '10px', top: '5px' }}>
                        <Typography> {data.currentTemperature}°F</Typography>
                    </Stack>
                </Grey.AutomationTitleSmall>
                <Grid marginX='25px' xs>
                    <Slider
                        disabled
                        color="primary"
                        marks={marks}
                        min={110}
                        max={140}
                        getAriaLabel={() => 'Temperature range'}
                        value={targetTemp}
                        step={1}
                        valueLabelDisplay="auto"
                    />
                </Grid>
            </Box>
        </Grey.CardTitleButton>
    </Box>
}

export function WaterHeaterPanel(props: PanelProps) {

    const theme = useTheme();
    const [data, setData] = useState(props.data as IWaterHeaterAutomationModel);
    const [targetTemp, setTargetTemp] = useState(data.targetTemperature);
    const [pulseColors, setPulseColors] = useState(GetPulseColor(data));

    const updateAll = (updated: IAutomationModel | null) => {
        var model = updated as IWaterHeaterAutomationModel;
        if (model) {
            setData(model);
            setTargetTemp(model.targetTemperature);
            setPulseColors(GetPulseColor(model));
        }
    }

    useEventHub<IWaterHeaterAutomationModel>(data.id, updateAll);

    const marks = [
        {
            value: 110,
            label: '110°F',
        },
        {
            value: targetTemp,
            label: `${targetTemp}°F`,
        },
        {
            value: 140,
            label: '140°F',
        },
    ];

    return (<Grey.AutomationCard key={data.id} className={`card card-${theme.name}`} variant="outlined">
        <CardContent sx={{ animation: `${pulseColors} 1.5s ease-in-out infinite alternate`, height: '100%' }}>
            <Grey.AutomationTitle>
                {data.title}
            </Grey.AutomationTitle>
            <div style={{ textAlign: "left" }}>
                <Typography>{data.isOn ? 'On' : 'Off'}</Typography>
                <Typography>Power Usage: {data.watts}w</Typography>
                <Typography>Current Temperature: {data.currentTemperature}°F</Typography>
                <Box sx={{ marginX: '20px', marginTop: '10px' }}>
                    <Grey.CustomSlider min={110} max={140} value={targetTemp} marks={marks} step={1} disabled />
                </Box>
            </div>
        </CardContent>
    </Grey.AutomationCard>
    );
}
